import { Injectable } from "@angular/core";
import { MODEL_TYPE, TUTORIAL_MODEL_KEY } from "../../common/linqset-model";

export const MAX_RIGHT_PANE_WIDTH= 1700
export const MAX_LEFT_PANE_WIDTH= 750
export const MIN_PANE_WIDTH=300
export const MIN_CANVAS_WIDTH=400      // side panels are narrowed or closed rather than squeezing the canvas below this

export const DEFAULT_RIGHT_PANE_FRACTION=0.4    // default insights panel width as a share of the window
export const TUTORIAL_RIGHT_PANE_WIDTH=700

export const DEFAULT_LEFT_PANE_WIDTH=525
export const MODELS_LEFT_PANE_WIDTH=550

const PANEL_WIDTHS_KEY = "linq.modelEditor.panelWidths"

@Injectable()
export class SidenavService {
    leftPaneWidth:number = DEFAULT_LEFT_PANE_WIDTH
    rightPaneWidth:number = this.defaultRightPaneWidth()

    constructor() {}

    defaultRightPaneWidth() {
        return Math.round(window.innerWidth*DEFAULT_RIGHT_PANE_FRACTION)
    }

    // widths the user has dragged to are remembered per browser; otherwise fall back to the defaults
    setSidenavWidths(modelType:MODEL_TYPE, modelKey:string) {
        const saved = this.loadWidths()
        this.leftPaneWidth = saved?.left || (modelType === MODEL_TYPE.PROCESS?DEFAULT_LEFT_PANE_WIDTH:MODELS_LEFT_PANE_WIDTH)
        this.rightPaneWidth = modelKey === TUTORIAL_MODEL_KEY?TUTORIAL_RIGHT_PANE_WIDTH:(saved?.right || this.defaultRightPaneWidth())
    }

    saveWidths() {
        try {
            localStorage.setItem(PANEL_WIDTHS_KEY, JSON.stringify({left:this.leftPaneWidth, right:this.rightPaneWidth}))
        }catch(err) {
            // storage unavailable; widths just won't persist
        }
    }

    private loadWidths():{left:number, right:number}|undefined {
        try {
            const saved = JSON.parse(localStorage.getItem(PANEL_WIDTHS_KEY))
            if (saved && typeof saved.left === 'number' && typeof saved.right === 'number') return saved
        }catch(err) {
            // storage unavailable or corrupt
        }
        return undefined
    }
}
